import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-cta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-cream" data-id="element-165">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-sage/10 rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-166" />
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-terracotta/10 rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-167" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-168">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-169">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-170">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-171">
              <span className="inline-block py-1 px-3 rounded-full bg-terracotta/10 text-terracotta-dark text-sm font-semibold tracking-wide mb-6" data-id="element-172">
                Para madres que buscan tranquilidad
              </span>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-forest mb-6 leading-tight" data-id="element-173">
                Son las 2AM. Tu hijo tiene fiebre. ¿Sabes exactamente qué hacer?
              </h1>

              <p className="text-lg md:text-xl text-forest/80 mb-8 leading-relaxed" data-id="element-174">
                Remedios naturales organizados por síntoma. Pasos claros. Sin
                pánico. Sin improvisar.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-8" data-id="element-175">
                <Button variant="primary" size="lg" onClick={scrollToPricing} className="w-full sm:w-auto shadow-xl shadow-terracotta/20" data-id="element-176">
                  Quiero Estar Preparada — Acceso Inmediato{' '}
                  <ArrowRight className="ml-2 h-5 w-5" data-id="element-177" />
                </Button>
              </div>

              <div className="flex items-center justify-center lg:justify-start gap-3 text-sm font-medium text-forest/70" data-id="element-178">
                <span className="line-through opacity-60" data-id="element-179">$19 USD</span>
                <span className="text-terracotta font-bold text-lg" data-id="element-180">
                  $6,39 USD
                </span>
                <span className="w-1 h-1 rounded-full bg-forest/30" data-id="element-181"></span>
                <span data-id="element-182">Oferta de lanzamiento</span>
              </div>
            </motion.div>
          </div>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-183">
            <div className="relative mx-auto max-w-md lg:max-w-full" data-id="element-184">
              <div className="absolute -inset-4 bg-sage/20 rounded-[2rem] blur-2xl transform rotate-3" data-id="element-185"></div>
              <img src="https://cdn.magicpatterns.com/uploads/unZichhruR5hEhX3jhYG9B/pequesalud_shopify.png" alt="PequeSalud Natural Guía" className="relative rounded-2xl shadow-2xl shadow-sage/20 w-full object-cover border-4 border-white transform -rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-186" />

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg border border-sage/10 flex items-center gap-3 animate-bounce-slow" data-id="element-187">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-188">
                  <CheckCircle className="h-6 w-6 text-green-600" data-id="element-189" />
                </div>
                <div data-id="element-190">
                  <p className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-191">
                    Disponible
                  </p>
                  <p className="text-forest font-bold" data-id="element-192">Descarga Inmediata</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}